import { VariableType } from 'json-to-graphql-query';

import { Media } from '@/interfaces/media';
import { EntityResource } from './entity.resource';

/**
 * Resource Plików
 *
 * @export
 * @class MediaResource
 * @extends {EntityResource<Media>}
 */
export class MediaResource extends EntityResource<Media> {
  public getFields = {
    id: true,
    title: true,
    size: true,
    contentType: true,
    isImage: true
  };

  public listFields = {
    id: true,
    title: true,
    size: true,
    contentType: true,
    isImage: true
  };

  constructor() {
    super({
      entityName: 'media'
    });
  }

  public listByIds(mediaIds: [number]): Promise<Media[]> {
    const query = this.prepareOptions({
      query: {
        __variables: { ids: '[Int!]!' },
        mediaListByIds: {
          __args: { ids: new VariableType('ids') },
          ...this.listFields
        }
      }
    });
    return this.query(
      {
        query,
        variables: { ids: mediaIds }
      },
      'mediaListByIds'
    );
  }
}

export const mediaResource = new MediaResource();
